import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { usePlanBuilder } from './context/PlanBuilderContext';
import Button from '../../../../ui/canon/Button';
import { PartyPopperIcon, ArrowRightIcon } from 'lucide-react';

// This component monitors module changes and shows a celebration overlay
const ModuleCelebration = () => {
  const intl = useIntl();
  const { progress } = usePlanBuilder();
  const [show, setShow] = useState(false);
  const [lastModuleId, setLastModuleId] = useState(null);

  useEffect(() => {
    if (progress?.currentModuleId) {
      if (lastModuleId && lastModuleId !== progress.currentModuleId) {
        // Module changed, show celebration
        setShow(true);
      }
      setLastModuleId(progress.currentModuleId);
    }
  }, [progress?.currentModuleId, lastModuleId]);

  if (!show) return null;

  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-in fade-in duration-300">
      <div className="bg-succession-bg-primary p-8 rounded-xl shadow-2xl max-w-md text-center border border-succession-border transform scale-100 animate-in zoom-in-95 duration-300">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <PartyPopperIcon className="w-8 h-8 text-green-600" />
        </div>
        
        <h2 className="text-2xl font-bold text-succession-text-primary mb-2">
          {intl.formatMessage({ id: 'succession.plans.module_celebration_title' })}
        </h2>
        <p className="text-succession-text-secondary mb-8">
          {intl.formatMessage({ id: 'succession.plans.module_celebration_description' })}
        </p>

        <Button
          variant="primary"
          size="lg"
          onClick={() => setShow(false)}
          className="w-full"
        >
          {intl.formatMessage({ id: 'succession.plans.module_celebration_continue' })} <ArrowRightIcon className="ml-2 w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};

export default ModuleCelebration;
